module.exports = __webpack_public_path__ + "707b12a7bf9abe97f23c48abb058a4b2.png";